import Typography from "components/Typography";
import floatButton from "./floatButton.png";

function ChatBubble({ onClick }: { onClick?: () => void }) {
  const expiredValidity = window.sessionStorage.getItem("expiredValidity");

  if (expiredValidity) return null;

  return (
    <div>
      <Typography onClick={onClick} className="speech-bubble" color="white">
        Olá, sou a SIG. Como posso te ajudar?
      </Typography>
      <img src={floatButton} className="floatIaButton" onClick={onClick} />
    </div>
  );
}
export default ChatBubble;
